import { render } from "./ElementController.vue?vue&type=template&id=0258286b&scoped=true"
import script from "./ElementController.vue?vue&type=script&lang=js"
export * from "./ElementController.vue?vue&type=script&lang=js"

import "./ElementController.vue?vue&type=style&index=0&id=0258286b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0258286b"]])

export default __exports__